import Check from '@mui/icons-material/Check';
import { Card, CardHeader, Stack, Typography } from '@mui/material';
import { Fare } from '@silbo/core';
import { colors } from '@silbo/ui';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { useOtherAssignedPorters } from '../hooks/useOtherAssignedPorters';
import FareCardContent from './FareCardContent';

type FareDoneCardProps = {
  fare: Fare;
};

const FareDoneCard = ({ fare }: FareDoneCardProps) => {
  const { t } = useTranslation('patient-transport');
  const { otherAssignedPorters } = useOtherAssignedPorters(fare);

  if (!fare.endedAt) {
    return null;
  }

  return (
    <Card sx={{ color: colors.grey[40] }}>
      <CardHeader
        title={
          <Stack direction="row" alignItems="center" gap={1}>
            <Check />
            <Typography fontStyle="italic" variant="body2">
              {t('fareDoneAt')} {format(fare.endedAt, 'HH:mm')}
            </Typography>
          </Stack>
        }
      />
      <FareCardContent fare={fare} otherAssignedPorters={otherAssignedPorters} isDone />
    </Card>
  );
};

export default FareDoneCard;
